import { useState } from "react";
import { db, storage } from "../firebase";
import { collection, addDoc, updateDoc, doc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Box, Button, Stepper, Step, StepLabel, CircularProgress, Typography, TextField, Grid } from "@mui/material";

const steps = ["Upload PDFs", "Upload Status", "Processing Status", "Validate Data"];

const UploadInvoices = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [processingStatus, setProcessingStatus] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const handleFileChange = (event) => {
    setFiles([...event.target.files]);
  };

  const handleUpload = async () => {
    const newUploads = {};
    const uploaded = [];

    for (let file of files) {
      const storageRef = ref(storage, `${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        newUploads[file.name] = progress;
        setUploadProgress({ ...newUploads });
      });

      // await uploadTask;
      // const downloadURL = await getDownloadURL(storageRef);
      // const docRef = await addDoc(collection(db, "invoices"), {
      //   fileName: file.name,
      //   fileUrl: downloadURL,
      //   status: "processing",
      // });
      uploaded.push({ fileName: file.name, status: "processing" });
    }

    setUploadedFiles(uploaded);
    setActiveStep(2);
  };

  const handleProcessingCheck = async () => {
    // Simulated check (replace with actual Firestore data retrieval)
    setProcessingStatus(uploadedFiles.map(file => ({ ...file, status: "processed" })));
    setActiveStep(3);
  };

  const handleValidation = async (invoice) => {
    await updateDoc(doc(db, "invoices", invoice.id), { status: "validated" });
    setProcessingStatus(processingStatus.map(item => item.id === invoice.id ? { ...item, status: "validated" } : item));
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <Box>
          <input type="file" multiple accept="application/pdf" onChange={handleFileChange} />
          <Button variant="contained" color="primary" onClick={() => setActiveStep(1)}>Next</Button>
        </Box>
      )}

      {activeStep === 1 && (
        <Box>
          {files.map((file) => (
            <Typography key={file.name}>{file.name}</Typography>
          ))}
          <Button variant="contained" color="primary" onClick={handleUpload}>Start Upload</Button>
          {Object.entries(uploadProgress).map(([file, progress]) => (
            <Typography key={file}>{file}: {progress}%</Typography>
          ))}
        </Box>
      )}

      {activeStep === 2 && (
        <Box>
          {uploadedFiles.map((file) => (
            <Typography key={file.id}>{file.fileName}: {file.status}</Typography>
          ))}
          <Button variant="contained" color="primary" onClick={handleProcessingCheck}>Check Processing Status</Button>
        </Box>
      )}

      {activeStep === 3 && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {processingStatus.map((invoice) => (
              <Box key={invoice.id} onClick={() => setSelectedInvoice(invoice)} sx={{ cursor: "pointer", p: 1, border: "1px solid #ccc", mb: 1 }}>
                <Typography>{invoice.fileName} - {invoice.status}</Typography>
              </Box>
            ))}
          </Grid>

            {selectedInvoice && (
              <>
              <Grid item xs={8}>
                <embed type="application/pdf" width="100%" height="800px" src={selectedInvoice.fileUrl} />
              </Grid>
             <Grid item xs={4}>

                <Box>
                <TextField label="Invoice Data" fullWidth margin="normal" defaultValue="Sample Invoice Data" />
                <TextField label="Vendor" fullWidth margin="normal" defaultValue="Sample Vendor" />
                <TextField label="Customer" fullWidth margin="normal" defaultValue="Sample Customer" />
                <TextField label="Due Date" fullWidth margin="normal" defaultValue="Sample Due Date" />
                <Button variant="contained" color="primary" onClick={() => handleValidation(selectedInvoice)}>Validate</Button>
              </Box>
              </Grid>
              </>
            )}
        </Grid>
      )}

      {activeStep === 4 && (
        <Typography>All invoices have been validated. Redirecting...</Typography>
      )}
    </Box>
  );
};

export default UploadInvoices;
